module.exports = __webpack_public_path__ + "static/media/thinking.025f17b5.jpg";